import { useEffect, useState } from 'react';
import { API_URL } from 'src/environments/environment';
import { Lesson } from 'pages/Education/Education.types';

export const scheduleDays = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
	'FRIDAY',
	'SATURDAY'
];

const useLessonsSchedule = () => {
  const [buttonLabels, setButtonLabels] = useState<string[]>([]);
  const [allLessonsByDays, setAllLessonsByDays] = useState<Lesson[][]>([]);
  const [filteredLessonsByDay, setFilteredLessonsByDay] = useState<Lesson[][]>([]);
  const [scheduledHours, setScheduledHours] = useState<string[]>([]);

  useEffect(() => {
    const getData = async () => {
      const data = await fetch(`${API_URL}/lessons-schedule`, {
        method: 'GET',
      });
      const jsonData: any = await data.json();
			debugger
      const lessonsByDays = scheduleDays
        .map((day) => {
					if (jsonData[day]) {
						return jsonData[day] as Lesson[];
					}
					return [];
				}) // get lesson schedule in the right day order
				.filter(l => !!l)
        .map((dayLessons) => dayLessons.sort((a: Lesson, b: Lesson) => { // sort day schedule by time
          if (a.startTime < b.startTime) {
            return -1;
          }
          if (a.startTime > b.startTime) {
            return 1;
          }
          return 0;
        }));
      const lessons = lessonsByDays.flat().sort((first, second) => {
        if (first.startTime < second.startTime) {
          return -1;
        }
        if (first.startTime > second.startTime) {
          return 1;
        }
        return 0;
      });
      setAllLessonsByDays(lessonsByDays);
      const minMaxAges = lessons.map((l) => ({
        minAge: l.minAge,
        maxAge: l.maxAge,
        minMax: `${l.minAge}-${l.maxAge}`,
        startTime: l.startTime,
      }));
      const ageLabels: any = {};
      const scheduleStartHours: any = {};
      minMaxAges.map((age) => {
        ageLabels[age.minMax] = age;
        scheduleStartHours[age.startTime] = age.startTime;
        return age;
      });
      setScheduledHours(Object.values(scheduleStartHours));
      const ageButtons = Object.keys(ageLabels).sort((first, second) => {
        if (parseInt(first.split('-')[0], 10) < parseInt(second.split('-')[0], 10)) {
          return -1;
        }
        if (parseInt(first.split('-')[0], 10) > parseInt(second.split('-')[0], 10)) {
          return 1;
        }
        return 0;
      });
      const initialAgeRange = minMaxAges.filter((age) => age.minMax === ageButtons[0]);
      setFilteredLessonsByDay(
        lessonsByDays
          .map((dayLessons) => dayLessons
            .filter(
              (lesson) => lesson.minAge === initialAgeRange[0].minAge
                && lesson.maxAge === initialAgeRange[0].maxAge,
            )),
      );
      setButtonLabels(ageButtons);
    };

    getData();
  }, []);

  return {
    buttonLabels,
    allLessonsByDays,
    filteredLessonsByDay,
    scheduledHours,
  };
};

export default useLessonsSchedule;
